module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Payments","customerManualConfirmThreshold":"Customer manual payment confirm threshold"},"et":{"title":"Payments","customerManualConfirmThreshold":"Customer manual payment confirm threshold"},"ru":{"title":"Payments","customerManualConfirmThreshold":"Customer manual payment confirm threshold"}}')
  delete Component.options._Ctor
}
